import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ResponseType } from '@/types/apiTypes';
import type { ClientDocumentResponse } from '@/types/clientsApiTypes';
import type { StoreDocumentRequest } from '@/types/documentsApiTypes';

export const useFinalizeUpload = () => {
  const { doFetch } = useFetch<StoreDocumentRequest, ResponseType<ClientDocumentResponse>>();

  return useMutation({
    mutationFn: async (options: StoreDocumentRequest) => {
      return doFetch('/api/documents/by/storage-id', {
        method: 'POST',
        body: options,
      });
    },
  });
};